import React from 'react';
import styles from './VisualShowcase.module.css';

const VisualShowcase = ({ type }) => {
  const renderVisual = () => {
    switch (type) {
      case 'ai':
        // No change, this one is good
        return (
          <div className={`${styles.visual} ${styles.aiChat}`}>
            <div className={styles.chatBubble} style={{ animationDelay: '0s' }}>Hello! How can I help you?</div>
            <div className={`${styles.chatBubble} ${styles.user}`} style={{ animationDelay: '1s' }}>I need to track my order.</div>
            <div className={styles.chatBubble} style={{ animationDelay: '2s' }}>Certainly. What's the order number? <span className={styles.cursor}>|</span></div>
          </div>
        );
      case 'analytics':
        // No change
        return (
          <div className={`${styles.visual} ${styles.analyticsGraph}`}>
            <svg viewBox="0 0 100 50">
              <path d="M 0 40 Q 25 10, 50 30 T 100 20" stroke="var(--primary-color)" fill="none" strokeWidth="2" />
            </svg>
          </div>
        );
      case 'web':
        // No change
        return (
          <div className={`${styles.visual} ${styles.webDev}`}>
            <div className={styles.code}>
              <code>&lt;div class="hero"&gt;</code>
              <code>  &lt;h1&gt;Welcome&lt;/h1&gt;</code>
              <code>&lt;/div&gt;</code>
            </div>
            <div className={styles.design}>
              <div className={styles.designBox}></div>
              <div className={styles.designLine}></div>
            </div>
          </div>
        );
      case 'mobile': // NEW VISUAL
        return (
          <div className={`${styles.visual} ${styles.mobileFrame}`}>
            <div className={styles.mobileScreen}>
              <div className={styles.mobileHeader}>My App</div>
              <div className={styles.mobileList}>
                <div className={styles.mobileItem}></div>
                <div className={styles.mobileItem}></div>
                <div className={styles.mobileItem}></div>
              </div>
            </div>
          </div>
        );
      case 'crm':
        // No change
        return (
          <div className={`${styles.visual} ${styles.crmDashboard}`}>
            <div className={styles.crmCard}>Leads<div className={styles.crmValue}>84</div></div>
            <div className={styles.crmCard}>Deals Won<div className={styles.crmValue}>12</div></div>
            <div className={styles.crmChart}>
              <div style={{ height: '40%' }}></div><div style={{ height: '70%' }}></div><div style={{ height: '60%' }}></div>
            </div>
          </div>
        );
      case 'ecommerce': // NEW VISUAL
        return (
          <div className={`${styles.visual} ${styles.ecommerceCard}`}>
            <div className={styles.ecomImage}></div>
            <div className={styles.ecomTitle}>Product Name</div>
            <button className={styles.ecomButton}>Add to Cart</button>
          </div>
        );
      case 'iot':
        // No change
        return (
          <div className={`${styles.visual} ${styles.iotNetwork}`}>
            <div className={styles.iotCenter}>💡</div>
            <div className={styles.iotNode1}>🏠</div>
            <div className={styles.iotNode2}>🌱</div>
            <div className={styles.iotNode3}>📱</div>
          </div>
        );
      case 'security': // NEW VISUAL
        return (
          <div className={`${styles.visual} ${styles.securityShield}`}>
            <div className={styles.shield}>🛡️</div>
            <div className={`${styles.dot} ${styles.threat1}`}></div>
            <div className={`${styles.dot} ${styles.threat2}`}></div>
            <div className={`${styles.dot} ${styles.safe1}`}></div>
            <div className={`${styles.dot} ${styles.safe2}`}></div>
          </div>
        );
      case 'dashboard':
      case 'industry40':
        return (
          <div className={`${styles.visual} ${styles.industryDashboard}`}>
            <div className={styles.dashboardHeader}>
              <div className={styles.dashboardTitle}>Industry 4.0 Dashboard</div>
              <div className={styles.dashboardStatus}>
                <span className={styles.statusDot}></span>
                <span>Live</span>
              </div>
            </div>
            <div className={styles.dashboardGrid}>
              <div className={styles.dashboardCard}>
                <div className={styles.cardLabel}>Production</div>
                <div className={styles.cardValue}>98%</div>
                <div className={styles.cardBar}>
                  <div className={styles.cardBarFill} style={{ width: '98%' }}></div>
                </div>
              </div>
              <div className={styles.dashboardCard}>
                <div className={styles.cardLabel}>Efficiency</div>
                <div className={styles.cardValue}>94%</div>
                <div className={styles.cardBar}>
                  <div className={styles.cardBarFill} style={{ width: '94%' }}></div>
                </div>
              </div>
              <div className={styles.dashboardCard}>
                <div className={styles.cardLabel}>Quality</div>
                <div className={styles.cardValue}>99.2%</div>
                <div className={styles.cardBar}>
                  <div className={styles.cardBarFill} style={{ width: '99.2%' }}></div>
                </div>
              </div>
              <div className={styles.dashboardCard}>
                <div className={styles.cardLabel}>Uptime</div>
                <div className={styles.cardValue}>99.8%</div>
                <div className={styles.cardBar}>
                  <div className={styles.cardBarFill} style={{ width: '99.8%' }}></div>
                </div>
              </div>
            </div>
            <div className={styles.dashboardChart}>
              <div className={styles.chartBar} style={{ height: '60%' }}></div>
              <div className={styles.chartBar} style={{ height: '80%' }}></div>
              <div className={styles.chartBar} style={{ height: '45%' }}></div>
              <div className={styles.chartBar} style={{ height: '90%' }}></div>
              <div className={styles.chartBar} style={{ height: '75%' }}></div>
              <div className={styles.chartBar} style={{ height: '85%' }}></div>
            </div>
          </div>
        );
      case 'consulting': // NEW VISUAL
      default:
        return (
          <div className={`${styles.visual} ${styles.consultingFlow}`}>
            <div className={styles.flowNode}>Problem ?</div>
            <div className={styles.flowArrow}>→</div>
            <div className={styles.flowNode}>Strategy</div>
            <div className={styles.flowArrow}>→</div>
            <div className={styles.flowNode}>Solution ✓</div>
          </div>
        );
    }
  };

  return <div className={styles.container}>{renderVisual()}</div>;
};

export default VisualShowcase;
